import { ParticelleList } from "./list";
import { useEffect, useState } from "react";
import { MinusIcon } from "../../../../ui/icons/minusIcon";
import { PlusIconAccordion } from "../../../../ui/icons/plusIcon";
import Accordion from "@mui/material/Accordion/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails/AccordionDetails";
import { ParticelleTools } from "./tools";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { resetCopyParcelFromNotificationStatus, resetExportCurrAndPrevNotStatus, resetUpdateParcelsFromCsvStatus } from "./slice";

export function Particelle() {
    const dispatch = useAppDispatch()
    const [expanded, setExpanded] = useState<string | false>(false);
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const parcelState = useAppSelector(state => state.parcel)

    const handleChangeAccordion =
        (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        };

    useEffect(() => {
        if(parcelState.copyParcelFromNotificationStatus === 'successfully') {
            dispatch(resetCopyParcelFromNotificationStatus())
            setShowSuccess(true)
        }
    }, [parcelState.copyParcelFromNotificationStatus])

    useEffect(() => {
        if(parcelState.exportCurrAndPrevNotStatus === 'successfully') {
            dispatch(resetExportCurrAndPrevNotStatus())
            setShowSuccess(true)
        }
    }, [parcelState.exportCurrAndPrevNotStatus])

    useEffect(() => {
        if(parcelState.updateParcelsFromCsvStatus === 'successfully') {
            dispatch(resetUpdateParcelsFromCsvStatus())
            setShowSuccess(true)
        }
    }, [parcelState.updateParcelsFromCsvStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <div id="boxAnagrafica" style={{ padding: '24px' }}>
            {
                showSuccess &&
                <div className="gap-[8px] text-left" style={{ margin: '24px', borderRadius: '12px', backgroundColor: '#D1F5D9', borderColor: '#8AE59F', borderWidth: 2 }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }

            {/* ACCORDION */}
            <Accordion expanded={expanded === 'panel1'} onChange={handleChangeAccordion('panel1')} defaultExpanded>
                <AccordionSummary
                    expandIcon={expanded === 'panel1' ? <MinusIcon /> : <PlusIconAccordion />}
                    aria-controls="panel1-content"
                    className="rounded-xl headingAccordion"
                    id="panel1-header"
                >
                    <div><span className="text-uppercase text-white label-input">Strumenti</span></div>
                </AccordionSummary>
                <AccordionDetails className="bg-brandPrimary-100" style={{ padding: '24px' }}>
                    <ParticelleTools />
                </AccordionDetails>
            </Accordion>

            {/* LISTING */}
            <div>
                <ParticelleList />
            </div>
        </div>
    )
}